import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { Button, Field, Input, Select } from "@/lib/ui";

export default function ReferBusiness() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", phone: "", company: "", category: "" });
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/public/filters").then(({ data }) => setCats(data.categories || [])).catch(() => {}); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/referor/referrals", form);
      toast.success("Business referred! You'll earn 10% when they buy a package."); nav("/referor/app");
    } catch (er) { toast.error(apiErr(er)); } finally { setLoading(false); }
  };
  return (
    <div className="max-w-xl">
      <h1 className="font-head text-2xl font-extrabold text-slate-900">Refer a Business</h1>
      <p className="mt-1 text-sm text-slate-500">When this business registers with the same mobile number and buys a package, 10% of the pre-tax amount is credited to you.</p>
      <form onSubmit={submit} className="mt-6 space-y-4 rounded-2xl border border-slate-200 bg-white p-5">
        <Field label="Contact Name" required><Input data-testid="refer-name" value={form.name} onChange={(e) => set("name", e.target.value)} required /></Field>
        <Field label="Phone Number" required><Input data-testid="refer-phone" value={form.phone} onChange={(e) => set("phone", e.target.value.replace(/\D/g, "").slice(0, 10))} placeholder="10-digit mobile" required /></Field>
        <Field label="Company Name" required><Input data-testid="refer-company" value={form.company} onChange={(e) => set("company", e.target.value)} required /></Field>
        <Field label="Category" required>
          {cats.length ? (
            <Select data-testid="refer-category" value={form.category} onChange={(e) => set("category", e.target.value)} required>
              <option value="">Select category</option>{cats.map((c) => <option key={c.id || c.name} value={c.name}>{c.name}</option>)}<option value="Other">Other</option>
            </Select>
          ) : <Input data-testid="refer-category" value={form.category} onChange={(e) => set("category", e.target.value)} required />}
        </Field>
        <Button data-testid="refer-submit" type="submit" disabled={loading} className="w-full">{loading ? "Submitting…" : "Submit Referral"}</Button>
      </form>
    </div>
  );
}
